﻿import {UtilityService} from "../../../services/shared/utility.service";

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'decimalDisplay'})
export class DecimalDisplayPipe implements PipeTransform {

  constructor(private utilityService:UtilityService){

  }

  transform(value:number): string {
    return this.utilityService.formatDecimal(value);
  }
}
